export default "__VITE_ASSET__83c3fd17__"